package ai.wagemix.web.screens.mixbuilder

import androidx.compose.runtime.remember
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.ui.modifiers.onKeyDown
import com.varabyte.kobweb.compose.ui.modifiers.tabIndex
import com.varabyte.kobweb.compose.ui.modifiers.role
import ai.wagemix.web.theme.WMHairGapVar
import ai.wagemix.web.components.WMIcon
import ai.wagemix.web.components.WMBadgeKind
import ai.wagemix.web.components.WMBadge
import ai.wagemix.web.components.WMPanelStyle
import ai.wagemix.web.components.WMDialogButtonStyle
import ai.wagemix.web.components.WMDialog
import ai.wagemix.web.components.WMBottomSheetDialogVariant
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import ai.wagemix.web.theme.WMInlineGapVar
import ai.wagemix.web.theme.WMOpacity
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import ai.wagemix.data.WMCache
import ai.wagemix.data.create
import ai.wagemix.logic.WMRoutes
import ai.wagemix.logic.mixbuilder.WMFilterOptions
import ai.wagemix.logic.mixbuilder.WMMixBuilderAccess
import ai.wagemix.logic.mixbuilder.WMMixBuilderPresenter
import ai.wagemix.logic.mixbuilder.WMMixBuilderTutorialStep
import ai.wagemix.logic.mixbuilder.WMMixDraftPresentation
import ai.wagemix.logic.mixbuilder.WMPremiumFeature
import ai.wagemix.logic.wages.WMDataQualityIssue
import ai.wagemix.logic.wages.WMOccupationDataStatus
import ai.wagemix.logic.wages.WMWageSummary
import ai.wagemix.web.components.WMBandChart
import ai.wagemix.web.components.WMBandChartFrame
import ai.wagemix.web.components.WMBandChartModel
import ai.wagemix.web.components.WMButton
import ai.wagemix.web.components.WMButtonKind
import ai.wagemix.web.components.WMButtonSize
import ai.wagemix.web.components.WMChartCard
import ai.wagemix.web.components.WMChartSource
import ai.wagemix.web.components.WMCoachmark
import ai.wagemix.web.components.WMCoachmarkSlot
import ai.wagemix.web.components.coachmarkTarget
import ai.wagemix.web.components.rememberWMCoachmarkTransition
import ai.wagemix.web.components.WMEmptyState
import ai.wagemix.web.components.WMFormat
import ai.wagemix.web.components.WMIconGlyph
import ai.wagemix.web.components.WMNotice
import ai.wagemix.web.components.WMNoticeKind
import ai.wagemix.web.components.WMOccupationRow
import ai.wagemix.web.components.WMOccupationRowPresentation
import ai.wagemix.web.components.WMPanel
import ai.wagemix.web.components.WMSegmentedControl
import ai.wagemix.web.components.WMComboBox
import ai.wagemix.web.components.WMSelectOption
import ai.wagemix.web.components.WMStatTile
import ai.wagemix.web.components.WMStepper
import ai.wagemix.web.components.of
import ai.wagemix.web.screens.WMWebStrings
import ai.wagemix.web.screens.formatShare
import ai.wagemix.web.screens.formatWage
import ai.wagemix.web.screens.formatWageRange
import ai.wagemix.web.theme.WMAppColumnLeftVar
import ai.wagemix.web.theme.WMBodySmallTextStyle
import ai.wagemix.web.theme.WMBodyTextStyle
import ai.wagemix.web.theme.WMPageTitleTextStyle
import ai.wagemix.web.theme.WMBodyStrongTextStyle
import ai.wagemix.web.theme.WMCaptionTextStyle
import ai.wagemix.web.theme.WMCardStackGapVar
import ai.wagemix.web.theme.WMLabelStrongTextStyle
import ai.wagemix.web.theme.WMLabelTextStyle
import ai.wagemix.web.theme.WMAppContentGapVar
import ai.wagemix.web.theme.WMStatTileGapVar
import ai.wagemix.web.theme.WMTabularTextStyle
import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.Div
import com.varabyte.kobweb.compose.ui.toAttrs
import androidx.compose.runtime.State
import com.fsryan.foundation.web.components.FSLoadingIndicator
import com.fsryan.foundation.web.theme.FSBreakpoint
import com.fsryan.foundation.web.theme.fs
import org.jetbrains.compose.web.css.FlexWrap
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.pointerEvents
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.gridTemplateColumns
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection

/** Two columns from Large up (left column 380), stacked below. */
val WMBuilderColumnsStyle = CssStyle {
    base { Modifier.fillMaxWidth().display(DisplayStyle.Flex).flexDirection(FlexDirection.Column).gap(WMAppContentGapVar.value()) }
    FSBreakpoint.Large { Modifier.flexDirection(FlexDirection.Row) }
}

/** The occupations and filters while the mix is re-evaluated: dimmed, and `inert` makes them unreachable. */
val WMReevaluatingStyle = CssStyle.base {
    Modifier.opacity(WMOpacity.DISABLED).cursor(Cursor.NotAllowed)
}

val WMBuilderLeftColumnStyle = CssStyle {
    base { Modifier.fillMaxWidth().display(DisplayStyle.Flex).flexDirection(FlexDirection.Column).gap(WMCardStackGapVar.value()) }
    FSBreakpoint.Large { Modifier.width(WMAppColumnLeftVar.value()).flexShrink(0) }
}

val WMStatTilesStyle = CssStyle {
    base { Modifier.fillMaxWidth().display(DisplayStyle.Grid).gridTemplateColumns { repeat(1) { size(1.fr) } }.gap(WMStatTileGapVar.value()) }
    FSBreakpoint.Medium { Modifier.gridTemplateColumns { repeat(3) { size(1.fr) } } }
}

/**
 * Penpot `Mix builder`: occupations and filters on the left, stat tiles, chart card, breakdown
 * and data-quality notice on the right. Stateless; every decision arrives as state.
 *
 * While [tutorialState] holds a step, its callout sits just above what the step points at, which is ringed: the
 * occupations panel, then the chart, its Annual/Hourly switch and its projection stepper.
 */
@Composable
fun WMMixBuilderScreenLayout(
    strings: WMWebStrings,
    loadingState: State<Boolean>,
    draftState: State<WMMixDraftPresentation?>,
    summaryState: State<WMWageSummary?>,
    chartModelState: State<WMBandChartModel?>,
    accessState: State<WMMixBuilderAccess?>,
    chartPrefsState: State<WMCache.Value.ChartPrefs?>,
    filterOptionsState: State<WMFilterOptions>,
    /** The mix is being re-evaluated: its occupations and filters cannot be used until that finishes. */
    reevaluatingState: State<Boolean>,
    tutorialState: State<WMMixBuilderTutorialStep?>,
    /** The API refused the draft's filter (a lapsed account's saved mix): a card stands in for the stats and chart. */
    chartLockedState: State<Boolean>,
    modifier: Modifier = Modifier,
    onAddOccupationClick: () -> Unit,
    onRemoveOccupation: (Int) -> Unit,
    onShareChange: (Int, Double) -> Unit,
    /** A row's weight slider was released (the share itself already arrived through [onShareChange]). */
    onShareCommit: (Int) -> Unit,
    onToggleLock: (Int) -> Unit,
    onToggleEnabled: (Int) -> Unit,
    onFiltersChange: (Int?, Int?) -> Unit,
    onChartPrefsChange: (Boolean, Int) -> Unit,
    onPremiumClick: (WMPremiumFeature) -> Unit,
    onDiscardClick: () -> Unit,
    /** The visitor pressed the Next or Done button of the tutorial step showing. */
    onTutorialStepComplete: (WMMixBuilderTutorialStep) -> Unit,
    onTutorialSkip: (WMMixBuilderTutorialStep) -> Unit
) {
    val colors = ColorMode.current.toPalette().fs
    val draft = draftState.value
    val summary = summaryState.value
    // Until the presenter says whether the visitor is signed in, render nothing: the logged-out "Try a mix" view would
    // otherwise flash every time a signed-in user opens a mix.
    val access = accessState.value ?: return
    val prefs = chartPrefsState.value
        ?: WMCache.Value.ChartPrefs.create(hourly = false, projectedYears = WMMixBuilderPresenter.DEFAULT_PROJECTED_YEARS)
    val weightsLocked = access == WMMixBuilderAccess.LoggedOut || access == WMMixBuilderAccess.Free || access == WMMixBuilderAccess.Lapsed
    val mb = strings.mixBuilder
    val filtered = draft?.areaId != null || draft?.industryId != null
    var filtersSheetOpen by remember { mutableStateOf(false) }
    // Trails tutorialState so a step fades out before the next one arrives and the last one before the tour ends.
    val tutorial = rememberWMCoachmarkTransition(tutorialState.value)

    Column(modifier = Modifier.fillMaxWidth().gap(WMAppContentGapVar.value()).then(modifier)) {
        if (access == WMMixBuilderAccess.LoggedOut) {
            Column(modifier = Modifier.fillMaxWidth().gap(4.px)) {
                SpanText(mb.tryTitle, WMPageTitleTextStyle.toModifier())
                SpanText(mb.tryLead, WMBodyTextStyle.toModifier().color(colors.onSurfaceVariant))
            }
        }
        when (access) {
            WMMixBuilderAccess.LoggedOut -> WMNotice(mb.loggedOutTitle, kind = WMNoticeKind.Info, message = mb.loggedOutMessage) {
                WMButton(strings.common.register, size = WMButtonSize.Sm) { kotlinx.browser.window.location.href = WMRoutes.REGISTER }
            }
            WMMixBuilderAccess.Free -> WMNotice(mb.freeTitle, kind = WMNoticeKind.AI, message = mb.freeMessage) {
                WMButton(strings.common.viewPlans, size = WMButtonSize.Sm) { kotlinx.browser.window.location.href = WMRoutes.PRICING }
            }
            else -> Unit
        }
        val reevaluating = reevaluatingState.value
        if (reevaluating) {
            WMNotice(mb.reevaluatingTitle, kind = WMNoticeKind.AI, message = mb.reevaluatingMessage)
        } else if (draft?.fromJobDescription == true && draft.sourceMixId != null) {
            WMNotice(mb.aiMixTitle, kind = WMNoticeKind.AI, message = mb.aiMixMessage)
        }

        Div(WMBuilderColumnsStyle.toModifier().toAttrs()) {
            // `inert` takes the occupations and filters out of reach (pointer, keyboard and assistive technology)
            // while the mix is re-evaluated; the chart and its options stay usable.
            Column(
                WMBuilderLeftColumnStyle.toModifier()
                    .thenIf(reevaluating) { WMReevaluatingStyle.toModifier().attrsModifier { attr("inert", "") } }
            ) {
                WMCoachmarkSlot(
                    transition = tutorial,
                    holds = { it == WMMixBuilderTutorialStep.AddOccupations },
                    spacing = WMCardStackGapVar.value(),
                ) { step ->
                    WMTutorialCoachmark(
                        strings = mb.tutorial,
                        step = step,
                        onAddOccupationClick = onAddOccupationClick,
                        onComplete = onTutorialStepComplete,
                        onSkip = onTutorialSkip,
                    )
                }
                WMPanel(
                    modifier = Modifier.coachmarkTarget(tutorial, WMMixBuilderTutorialStep.AddOccupations),
                    title = mb.occupations,
                    action = { WMButton(mb.addOccupation, kind = WMButtonKind.Secondary, size = WMButtonSize.Sm, leadingIcon = WMIconGlyph.Plus, onClick = onAddOccupationClick) }
                ) {
                    if (draft == null || draft.isEmpty) {
                        WMEmptyState(WMIconGlyph.Layers, mb.emptyTitle, mb.emptyMessage) {
                            WMButton(mb.addOccupation, size = WMButtonSize.Sm, onClick = onAddOccupationClick)
                        }
                    } else {
                        draft.rows.forEach { row ->
                            WMOccupationRow(
                                row = WMOccupationRowPresentation.of(
                                    id = row.occupationId,
                                    name = row.title,
                                    caption = mb.statusCaption(
                                        status = summary?.occupationStatus?.get(row.occupationId),
                                        filtered = filtered
                                    ),
                                    weightPercent = row.share * 100,
                                    enabled = row.enabled,
                                    locked = row.locked,
                                    counted = row.hasData
                                ),
                                strings = mb.row,
                                weightsLocked = weightsLocked,
                                onWeightChange = { pct -> onShareChange(row.occupationId, pct / 100.0) },
                                onWeightCommit = { onShareCommit(row.occupationId) },
                                onToggleLock = { onToggleLock(row.occupationId) },
                                onToggleEnabled = { onToggleEnabled(row.occupationId) },
                                onRemove = { onRemoveOccupation(row.occupationId) },
                                onLockedWeightClick = { onPremiumClick(WMPremiumFeature.Weights) }
                            )
                        }
                        Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                            SpanText(mb.total, WMLabelTextStyle.toModifier().color(colors.onSurfaceVariant).fillMaxWidth())
                            SpanText(formatShare(draft.rows.filter { it.enabled }.sumOf { it.share }), WMLabelStrongTextStyle.toModifier())
                        }
                        if (draft.dirty && draft.sourceMixId != null) {
                            WMButton(mb.discard, kind = WMButtonKind.Secondary, size = WMButtonSize.Sm, leadingIcon = WMIconGlyph.RefreshCw, onClick = onDiscardClick)
                        }
                    }
                }

                // From Medium up the panel; below it one row that opens the filters in a sheet (design deviation H1).
                Box(Modifier.fillMaxWidth().displayIfAtLeast(Breakpoint.MD)) {
                    WMFiltersPanel(
                        strings = strings,
                        draft = draft,
                        options = filterOptionsState.value,
                        locked = weightsLocked,
                        onFiltersChange = onFiltersChange,
                        onLockedClick = { onPremiumClick(WMPremiumFeature.Filters) }
                    )
                }
                Box(Modifier.fillMaxWidth().displayUntil(Breakpoint.MD)) {
                    WMFiltersSummaryRow(strings, draft, locked = weightsLocked) {
                        if (weightsLocked) {
                            onPremiumClick(WMPremiumFeature.Filters)
                        } else {
                            filtersSheetOpen = true
                        }
                    }
                }
                if (filtersSheetOpen) {
                    WMFiltersSheet(strings, draft, filterOptionsState.value, onFiltersChange) { filtersSheetOpen = false }
                }
            }

            Column(modifier = Modifier.fillMaxWidth().minWidth(0.px).flexGrow(1).gap(WMCardStackGapVar.value())) {
                if (chartLockedState.value) {
                    val lapsed = access == WMMixBuilderAccess.Lapsed
                    WMChartLockedCard(strings, draft, lapsed = lapsed, onClearFilter = { onFiltersChange(null, null) })
                    return@Column
                }
                WMStatTiles(strings, summary, prefs.hourly)
                WMCoachmarkSlot(
                    transition = tutorial,
                    holds = { it != WMMixBuilderTutorialStep.AddOccupations },
                    spacing = WMCardStackGapVar.value(),
                ) { step ->
                    WMTutorialCoachmark(
                        strings = mb.tutorial,
                        step = step,
                        onAddOccupationClick = onAddOccupationClick,
                        onComplete = onTutorialStepComplete,
                        onSkip = onTutorialSkip,
                    )
                }
                WMChartCard(
                    title = mb.chartTitle,
                    subtitle = draft?.let { listOfNotNull(it.areaName ?: mb.anyArea, it.industryName ?: mb.anyIndustry).joinToString(" · ") },
                    controls = {
                        Row(modifier = Modifier.gap(12.px).flexWrap(FlexWrap.Wrap), verticalAlignment = Alignment.CenterVertically) {
                            WMSegmentedControl(
                                options = listOf(strings.common.annual, strings.common.hourly),
                                selectedIndex = if (prefs.hourly) 1 else 0,
                                onSelect = { onChartPrefsChange(it == 1, prefs.projectedYears) },
                                modifier = Modifier.coachmarkTarget(tutorial, WMMixBuilderTutorialStep.ChartMode),
                                accessibilityString = "${strings.common.annual} / ${strings.common.hourly}"
                            )
                            Row(
                                modifier = Modifier.gap(8.px)
                                    .coachmarkTarget(tutorial, WMMixBuilderTutorialStep.ChartProjection),
                                verticalAlignment = Alignment.CenterVertically,
                            ) {
                                SpanText(mb.projection, WMLabelTextStyle.toModifier().color(colors.onSurfaceVariant))
                                WMStepper(
                                    valueText = "+${prefs.projectedYears}",
                                    onDecrement = { onChartPrefsChange(prefs.hourly, prefs.projectedYears - 1) },
                                    onIncrement = { onChartPrefsChange(prefs.hourly, prefs.projectedYears + 1) },
                                    decrementLabel = mb.projectionLess,
                                    incrementLabel = mb.projectionMore,
                                    canDecrement = prefs.projectedYears > 0,
                                    canIncrement = prefs.projectedYears < WMMixBuilderPresenter.MAX_PROJECTED_YEARS
                                )
                            }
                        }
                    },
                    footer = {
                        Column(modifier = Modifier.gap(4.px)) {
                            WMChartSource(strings.common.dataSource)
                            if (summary?.points?.any { it.projected } == true) WMChartSource(strings.common.projectedNote)
                        }
                    }
                ) {
                    val model = chartModelState.value
                    // One reserved 4:3 box for the chart and whatever stands in for it, so the card never resizes.
                    val chartTarget = Modifier.coachmarkTarget(tutorial, WMMixBuilderTutorialStep.ChartData)
                    WMBandChartFrame(modifier = chartTarget) {
                        when {
                            loadingState.value && model == null -> FSLoadingIndicator(strings.common.loading)
                            model == null -> SpanText(mb.noStats, WMBodySmallTextStyle.toModifier().color(colors.onSurfaceVariant))
                            model.points.isEmpty() && filtered -> WMNotice(mb.noDataForFilters, kind = WMNoticeKind.Info)
                            model.points.isEmpty() -> SpanText(mb.noStats, WMBodySmallTextStyle.toModifier().color(colors.onSurfaceVariant))
                            else -> WMBandChart(model = model, description = mb.chartDescription)
                        }
                    }
                }

                summary?.let { s ->
                    if (s.qualityIssues.isNotEmpty()) {
                        WMNotice(
                            title = mb.dataQualityTitle,
                            kind = WMNoticeKind.Warning,
                            message = s.qualityIssues.sorted().joinToString(" ") {
                                when (it) {
                                    WMDataQualityIssue.Backfilled -> mb.backfilled
                                    WMDataQualityIssue.Projected -> mb.projected(s.points.filterNot { p -> p.projected }.maxOfOrNull { p -> p.year } ?: s.points.first().year)
                                    WMDataQualityIssue.Capped -> mb.capped
                                    WMDataQualityIssue.Missing -> mb.missing
                                }
                            }
                        )
                    }
                    if (s.breakdown.isNotEmpty()) WMBreakdownTable(strings, s, filtered)
                }
            }
        }
    }
}

/**
 * The callout of the tutorial [step]: where it is in the tour, what to do, and its buttons. The first step's button
 * opens the occupation picker (adding occupations is what ends it); the chart steps move on with Next, or Done on
 * the last. Its slot fades it in and out, and keys it by step, so each step is a new callout.
 */
@Composable
private fun WMTutorialCoachmark(
    strings: WMWebStrings.MixBuilderTutorial,
    step: WMMixBuilderTutorialStep,
    onAddOccupationClick: () -> Unit,
    onComplete: (WMMixBuilderTutorialStep) -> Unit,
    onSkip: (WMMixBuilderTutorialStep) -> Unit
) {
    val (title, message) = when (step) {
        WMMixBuilderTutorialStep.AddOccupations -> strings.addOccupationsTitle to strings.addOccupationsMessage
        WMMixBuilderTutorialStep.ChartData -> strings.chartDataTitle to strings.chartDataMessage
        WMMixBuilderTutorialStep.ChartMode -> strings.chartModeTitle to strings.chartModeMessage
        WMMixBuilderTutorialStep.ChartProjection -> strings.chartProjectionTitle to strings.chartProjectionMessage
    }
    val last = step == WMMixBuilderTutorialStep.entries.last()
    WMCoachmark(
        title = title,
        message = message,
        progress = strings.progress(step.ordinal + 1, WMMixBuilderTutorialStep.entries.size)
    ) {
        if (!last) {
            WMButton(strings.skip, kind = WMButtonKind.Ghost, size = WMButtonSize.Sm) { onSkip(step) }
        }
        when {
            step == WMMixBuilderTutorialStep.AddOccupations -> {
                WMButton(
                    text = strings.addOccupationsAction,
                    size = WMButtonSize.Sm,
                    leadingIcon = WMIconGlyph.Plus,
                    onClick = onAddOccupationClick,
                )
            }
            last -> WMButton(strings.done, size = WMButtonSize.Sm) { onComplete(step) }
            else -> WMButton(strings.next, size = WMButtonSize.Sm) { onComplete(step) }
        }
    }
}

/**
 * Penpot `Mix Builder / … · Lapsed (filter)`: what replaces the stat tiles and the chart when `/chart` refuses the
 * draft's filter for the plan. A lapsed account is offered to renew, any other to view plans; either can clear it.
 */
@Composable
private fun WMChartLockedCard(strings: WMWebStrings, draft: WMMixDraftPresentation?, lapsed: Boolean, onClearFilter: () -> Unit) {
    val r = strings.renewal
    val filter = draft?.areaName ?: draft?.industryName ?: ""
    WMEmptyState(
        glyph = WMIconGlyph.Lock,
        title = r.chartLockedTitle(filter),
        message = if (lapsed) r.chartLockedMessage else r.chartLockedUpgradeMessage,
    ) {
        Row(modifier = Modifier.gap(WMInlineGapVar.value()).flexWrap(FlexWrap.Wrap), verticalAlignment = Alignment.CenterVertically) {
            WMButton(if (lapsed) r.renew else strings.common.viewPlans) { kotlinx.browser.window.location.href = WMRoutes.PRICING }
            WMButton(r.clearFilter, kind = WMButtonKind.Secondary, onClick = onClearFilter)
        }
    }
}

@Composable
private fun WMStatTiles(strings: WMWebStrings, summary: WMWageSummary?, hourly: Boolean) {
    val mb = strings.mixBuilder
    val h = summary?.headline
    val year = h?.year?.toString() ?: ""
    val projected = summary?.points?.lastOrNull { it.year == h?.year }?.projected == true
    Div(WMStatTilesStyle.toModifier().toAttrs()) {
        WMStatTile(
            label = mb.median,
            value = formatWage(h?.median, hourly),
            caption = h?.medianYearOverYear?.let { "${WMFormat.percentDelta(it)} · $year" } ?: year,
            projected = projected,
            highlight = true
        )
        WMStatTile(label = mb.middleHalf, value = formatWageRange(h?.p25, h?.p75, hourly), caption = year, projected = projected)
        WMStatTile(label = mb.typicalRange, value = formatWageRange(h?.p10, h?.p90, hourly), caption = year, projected = projected)
    }
}

@Composable
private fun WMBreakdownTable(strings: WMWebStrings, summary: WMWageSummary, filtered: Boolean) {
    val colors = ColorMode.current.toPalette().fs
    val mb = strings.mixBuilder
    WMPanel(title = mb.breakdown) {
        Row(modifier = Modifier.fillMaxWidth().gap(12.px)) {
            SpanText(mb.occupationColumn, WMLabelTextStyle.toModifier().color(colors.onSurfaceVariant).fillMaxWidth())
            SpanText(mb.shareColumn, WMLabelTextStyle.toModifier().color(colors.onSurfaceVariant).width(64.px))
            SpanText(mb.medianColumn, WMLabelTextStyle.toModifier().color(colors.onSurfaceVariant).width(96.px))
        }
        summary.breakdown.forEach { row ->
            Row(modifier = Modifier.fillMaxWidth().gap(12.px), verticalAlignment = Alignment.CenterVertically) {
                Column(modifier = Modifier.fillMaxWidth().minWidth(0.px)) {
                    SpanText(row.title, WMBodyStrongTextStyle.toModifier())
                    mb.statusCaption(summary.occupationStatus[row.occupationId], filtered)?.let {
                        SpanText(it, WMCaptionTextStyle.toModifier().color(colors.onSurfaceVariant))
                    }
                }
                SpanText(formatShare(row.share), WMTabularTextStyle.toModifier().width(64.px))
                SpanText(formatWage(row.median, summary.hourly), WMTabularTextStyle.toModifier().width(96.px))
            }
        }
    }
}

/** The filters panel (Penpot `Filter Panel`) from Medium up: Clear in the header, the fields under it. */
@Composable
private fun WMFiltersPanel(
    strings: WMWebStrings,
    draft: WMMixDraftPresentation?,
    options: WMFilterOptions,
    locked: Boolean,
    onFiltersChange: (Int?, Int?) -> Unit,
    onLockedClick: () -> Unit
) {
    val mb = strings.mixBuilder
    val hasFilter = draft?.areaId != null || draft?.industryId != null
    WMPanel(
        title = mb.filters,
        action = {
            if (hasFilter) WMButton(mb.clearFilters, kind = WMButtonKind.Ghost, size = WMButtonSize.Sm) { onFiltersChange(null, null) }
        }
    ) {
        WMFiltersFields(strings, draft, options, locked, onFiltersChange, onLockedClick)
    }
}

/** The filters themselves: the locked notice, Area, Industry and the "not both" hint. The panel and the sheet share it. */
@Composable
private fun WMFiltersFields(
    strings: WMWebStrings,
    draft: WMMixDraftPresentation?,
    options: WMFilterOptions,
    locked: Boolean,
    onFiltersChange: (Int?, Int?) -> Unit,
    onLockedClick: () -> Unit
) {
    val mb = strings.mixBuilder
    val colors = ColorMode.current.toPalette().fs
    if (locked) {
        WMNotice(mb.filtersLocked, kind = WMNoticeKind.Info) {
            WMButton(strings.common.viewPlans, kind = WMButtonKind.Secondary, size = WMButtonSize.Sm, onClick = onLockedClick)
        }
    }
    // A locked plan sees the selects disabled; a click on one explains why instead of seeming to change it.
    val lockedSelect = if (locked) Modifier.fillMaxWidth().pointerEvents(PointerEvents.None) else Modifier.fillMaxWidth()
    val lockedClick = if (locked) Modifier.cursor(Cursor.Pointer).onClick { onLockedClick() } else Modifier
    // A mix filters by an area or by an industry: while one is chosen the other select is disabled.
    val areaChosen = draft?.areaId != null
    val industryChosen = draft?.industryId != null
    SpanText(mb.area, WMLabelTextStyle.toModifier().color(colors.onSurfaceVariant))
    Box(modifier = Modifier.fillMaxWidth().then(lockedClick)) {
        WMComboBox(
            options = listOf(WMSelectOption("", mb.anyArea)) + options.areas.map { WMSelectOption(it.id.toString(), "${it.name}, ${it.primaryState}") },
            selectedValue = draft?.areaId?.toString() ?: "",
            accessibilityString = mb.area,
            noMatchesText = mb.noFilterMatches,
            modifier = lockedSelect,
            enabled = !locked && !industryChosen,
            onSelect = { value -> onFiltersChange(value.toIntOrNull(), draft?.industryId) }
        )
    }
    SpanText(mb.industry, WMLabelTextStyle.toModifier().color(colors.onSurfaceVariant))
    Box(modifier = Modifier.fillMaxWidth().then(lockedClick)) {
        WMComboBox(
            options = listOf(WMSelectOption("", mb.anyIndustry)) + options.industries.map { WMSelectOption(it.id.toString(), it.naicsTitle) },
            selectedValue = draft?.industryId?.toString() ?: "",
            accessibilityString = mb.industry,
            noMatchesText = mb.noFilterMatches,
            modifier = lockedSelect,
            enabled = !locked && !areaChosen,
            onSelect = { value -> onFiltersChange(draft?.areaId, value.toIntOrNull()) }
        )
    }
    if (!locked && (areaChosen || industryChosen)) {
        SpanText(mb.filtersExclusive, WMBodySmallTextStyle.toModifier().color(colors.onSurfaceVariant))
    }
}

/**
 * Below Medium the filters are one row (Penpot `Mix Builder / Compact`, design deviation H1): what is chosen, and a
 * chevron that opens them in a bottom sheet. On a plan without filters the row says so beside a Premium badge, and a
 * tap explains the lock instead of opening the sheet.
 */
@Composable
internal fun WMFiltersSummaryRow(strings: WMWebStrings, draft: WMMixDraftPresentation?, locked: Boolean, onClick: () -> Unit) {
    val mb = strings.mixBuilder
    val colors = ColorMode.current.toPalette().fs
    val chosen = listOfNotNull(draft?.areaName, draft?.industryName).joinToString(" · ").ifEmpty { null }
    val value = when {
        !locked -> "${draft?.areaName ?: mb.anyArea} · ${draft?.industryName ?: mb.anyIndustry}"
        chosen != null -> mb.filtersNeedPlanWith(chosen)
        else -> mb.filtersNeedPlan
    }
    Row(
        modifier = WMPanelStyle.toModifier()
            .cursor(Cursor.Pointer)
            .role("button")
            .tabIndex(0)
            .attrsModifier { if (!locked) attr("aria-haspopup", "dialog") }
            .onClick { onClick() }
            .onKeyDown { if (it.key == "Enter" || it.key == " ") onClick() },
        verticalAlignment = Alignment.CenterVertically
    ) {
        WMIcon(WMIconGlyph.SlidersHorizontal, accessibilityString = null, modifier = Modifier.flexShrink(0).color(colors.onSurfaceVariant))
        Column(modifier = Modifier.fillMaxWidth().minWidth(0.px).gap(WMHairGapVar.value())) {
            SpanText(mb.filters, WMLabelStrongTextStyle.toModifier())
            SpanText(value, WMBodySmallTextStyle.toModifier().color(colors.onSurfaceVariant))
        }
        if (locked) {
            WMBadge(mb.premium, kind = WMBadgeKind.Plan, icon = WMIconGlyph.Lock)
        } else {
            WMIcon(WMIconGlyph.ChevronRight, accessibilityString = null, modifier = Modifier.flexShrink(0).color(colors.onSurfaceVariant))
        }
    }
}

/** The phone filters in a bottom sheet: the same fields as the panel, with Clear and Done under them. */
@Composable
internal fun WMFiltersSheet(
    strings: WMWebStrings,
    draft: WMMixDraftPresentation?,
    options: WMFilterOptions,
    onFiltersChange: (Int?, Int?) -> Unit,
    onClose: () -> Unit
) {
    val mb = strings.mixBuilder
    val hasFilter = draft?.areaId != null || draft?.industryId != null
    WMDialog(
        title = mb.filters,
        onDismiss = onClose,
        variant = WMBottomSheetDialogVariant,
        actions = {
            if (hasFilter) {
                WMButton(mb.clearFilters, kind = WMButtonKind.Ghost, modifier = WMDialogButtonStyle.toModifier()) { onFiltersChange(null, null) }
            }
            WMButton(strings.common.close, modifier = WMDialogButtonStyle.toModifier(), onClick = onClose)
        }
    ) {
        Column(modifier = Modifier.fillMaxWidth().gap(WMInlineGapVar.value())) {
            WMFiltersFields(strings, draft, options, locked = false, onFiltersChange = onFiltersChange, onLockedClick = {})
        }
    }
}

/** The caption that marks an occupation the stats response left incomplete, or `null` when it was complete. */
private fun WMWebStrings.MixBuilder.statusCaption(status: WMOccupationDataStatus?, filtered: Boolean): String? {
    return when (status) {
        null -> null
        WMOccupationDataStatus.NoData -> if (filtered) occupationNoDataForFilter else occupationNoData
        is WMOccupationDataStatus.Estimated -> occupationEstimated(status.years, status.basedOn)
    }
}
